import { hubConnectionManager } from "@/signalR/hubConnectionManager";
import { videoOptions } from "@/config";
import type { MediaKind } from "mediasoup-client/types";
import type { JoinRoomResult } from "@/types/joinRoomResult";
import type { HubConnection } from "@microsoft/signalr";
import type { CameraState } from "@/enums/CameraState";

export function useVideoHub(videoId: string) {
  const hub = hubConnectionManager(
    `${videoOptions.EMS_SERVER_URL}/hub/video/${videoId}`
  );

  async function startConnection(): Promise<HubConnection> {
    const connection = await hub.start();
    return connection;
  }

  async function joinRoom(): Promise<JoinRoomResult | null> {
    return await hub.invoke("JoinRoom");
  }

  async function createWebRtcTransport() {
    return await hub.invoke("CreateWebRtcTransport");
  }

  async function connectWebRtcTransport(dtlsParameters: any) {
    return await hub.invoke("ConnectWebRtcTransport", dtlsParameters);
  }

  async function produce(kind: MediaKind, rtpParameters: any): Promise<string | null> {
    return await hub.invoke<string>("Produce", kind, rtpParameters);
  }

  async function setCameraState(cameraState: CameraState): Promise<void> {
    await hub.invoke("SetCameraState", cameraState);
  }

  async function sendProducerStats(stats: any): Promise<void> {
    await hub.invoke("SendProducerStats", stats);
  }

  async function disconnect() {
    await hub.stop();
  }

  return {
    startConnection,
    joinRoom,
    createWebRtcTransport,
    connectWebRtcTransport,
    produce,
    setCameraState,
    sendProducerStats,
    disconnect
  };
}
